import React, { useEffect, useState } from 'react';

import styles from '../CampaignPictures/CampaignPictures.module.css';
import { AD_TYPES } from '../../../constants/enums';

const CampaignExperience = ({ mediaArray }) => {
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [mediaDimensions, setMediaDimensions] = useState({});

    useEffect(() => {
        if (selectedMedia) {
            document.body.classList.add('modalOpen');

            return () => document.body.classList.remove('modalOpen');
        }

        document.body.classList.remove('modalOpen');
    }, [selectedMedia]);

    const handleMediaLoad = (event, mediaUrl) => {
        const { naturalWidth, naturalHeight, videoWidth, videoHeight } = event.target;

        setMediaDimensions(prev => ({
            ...prev,
            [mediaUrl]: {
                width: videoWidth || naturalWidth || 0,
                height: videoHeight || naturalHeight || 0
            }
        }));
    };

    const openSelectedMedia = (media) => {
        setSelectedMedia(media);
    };

    const handleMediaKeyDown = (event, media) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openSelectedMedia(media);
        }
    };

    const MediaModal = ({ media, onClose }) => {
        const mediaUrl = media?.src || media?.url;

        return (
            <div className={styles.modal} onClick={onClose}>
                <div className={styles.modalContent} onClick={(event) => event.stopPropagation()}>
                    {media.type === AD_TYPES.VIDEO ? (
                        <video
                            src={mediaUrl}
                            className={styles.modalImage}
                            controls
                            autoPlay
                        >
                            Your browser does not support the video tag.
                        </video>
                    ) : (
                        <img
                            src={mediaUrl}
                            alt={media.alt || 'Enlarged campaign experience'}
                            className={styles.modalImage}
                        />
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div className={styles.imageContainer}>
                    {mediaArray?.map((media, index) => {
                        const mediaUrl = media.src || media.url;
                        const dimensions = mediaDimensions[mediaUrl] || {};
                        const isLandscape = dimensions.width > dimensions.height;

                        return (
                            <div
                                key={media.id || mediaUrl || index}
                                className={styles.imageWrapper}
                                style={{
                                    height: isLandscape ? '300px' : '300px'
                                }}
                            >
                                <div
                                    className={styles.imageInner}
                                    onClick={() => openSelectedMedia(media)}
                                    onKeyDown={(event) => handleMediaKeyDown(event, media)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    {media.type === AD_TYPES.VIDEO ? (
                                        <video
                                            src={mediaUrl}
                                            className={styles.image}
                                            muted
                                            playsInline
                                            preload="metadata"
                                            onLoadedMetadata={(event) => handleMediaLoad(event, mediaUrl)}
                                        >
                                            Your browser does not support the video tag.
                                        </video>
                                    ) : (
                                        <img
                                            src={mediaUrl}
                                            alt={media.alt || `Campaign experience ${index + 1}`}
                                            className={styles.image}
                                            onLoad={(event) => handleMediaLoad(event, mediaUrl)}
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {selectedMedia && (
                <MediaModal
                    media={selectedMedia}
                    onClose={() => setSelectedMedia(null)}
                />
            )}
        </div>
    );
};

export default CampaignExperience;